module.exports = __webpack_public_path__ + "static/media/BCP_LOGO_ICON.707e7daf.svg";